<template>
  <div class="exam-header-warp">
    <div class="header-content">
        <div class="left">
        <template v-if="canClickLogo">
          <router-link :to="{name: 'paperListTeacher'}"><img src="@/common/images/student/logo_header.png" alt=""></router-link>
        </template>
        <img v-else src="@/common/images/student/logo_header.png" alt="">
      </div>
      <div class="right" v-if="loginStatus">
        <slot name="extend"></slot>
        <div class="teacher-page-hd-roles" v-if="userInfo && userInfo.roles?.length > 0">
          <roles-tag role="ADMIN" v-if="userInfo.roles.includes('ADMIN')"></roles-tag>
          <roles-tag role="TEACHER" v-if="userInfo.roles.includes('TEACHER')"></roles-tag>
        </div>
        <div class="right-userWrap">
          <div class="user-img"><img class="user-img_img" src="@/common/images/student/img_avatar.png"/></div>
          <div class="user-nick">{{userInfo?.username || '我的'}}</div>
          <div class="dropdown-menu">
            <div class="dropdown-item item-switch" @click="logout">切换账号</div>
            <div class="dropdown-item item-logout" @click="logout">退出登录</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { getUserLoginStatus, exitUser } from '@/api/api';
  import { getUser } from '@/api/user';
  import { addReportParam } from '@/common/js/track';
  import {ROLE_MAP} from '@/common/constant/qz';
  import RolesTag from './rolesTag.vue';
  export default {
    name: 'teacherExamHeader',
    components: {
      RolesTag
    },
    props: {
      canClickLogo: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        loginStatus: false,
        userInfo: null,
        ROLE_MAP
      }
    },
    computed: {
      sortedRoles() {
        if (!this.userInfo?.roles) return [];
        return [...this.userInfo.roles].sort((a, b) => {
          // ADMIN 始终排在第一位
          if (a === 'ADMIN') return -1;
          if (b === 'ADMIN') return 1;
          // 其他角色保持原有顺序
          return 0;
        });
      }
    },
    created() {
      this.getUserLoginStatus();
    },
    methods: {
      getUserLoginStatus() {
        getUserLoginStatus().then((res) => {
          if (res.body.login === true) {
            this.loginStatus = true;
            this.updateUserInfo();
          } else {
            this.loginStatus = false;
          }
        });
      },
      updateUserInfo() {
        getUser()
          .then((res) => {
            this.userInfo = res || {};
            localStorage.setItem('userInfo', JSON.stringify(this.userInfo));
          })
          .catch((err) => {
            console.error(err);
          });
      },
      logout() {
        localStorage.removeItem('userInfo');
        exitUser();
      },
      handleLogoClick() {
        if (!this.canClickLogo) return;
        this.$router.push({ name: 'home' });
      }
    }
  }
</script>
<style scoped lang="less">
  .exam-header-warp{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 2;
    height: 72px;
    background: #ffffff;
    display: flex;
    align-items: stretch;
    .header-content{
      display: flex;
      justify-content: space-between;
      width: 100%;
      // min-width: 1200px;
      padding: 0 5.2%;
      align-items: stretch;
      box-sizing: border-box;
      .left{
        display: flex;
        align-items: center;
        img {
          height: 32px;
        }
      }
      .right{
        position: relative;
        display: flex;
        align-items: center;
        height: 100%;
        .teacher-page-hd-roles{
          display: flex;
          align-items: center;
          gap: 10px;
          margin-left: 30px;
        }
        &-link, .user-nick{
          font-size: 16px;
          color: #616161;
          font-weight: 500;
        }
        &-link {
          margin-right: 30px;
        }
        .user-img{
          width: 28px;
          height: 28px;
          border-radius: 50%;
          margin-right: 8px;
        }
        .user-img_img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
        .right-userWrap {
          display: flex;
          align-items: center;
          position: relative;
          margin-left: 30px;
          &:hover {
            .dropdown-menu {
              opacity: 1;
              transform: scale(1);
            }
          }
        }
        .dropdown-menu {
          position: absolute;
          top: 40px;
          left: 10px;
          border-radius: 12px;
          opacity: 1;
          background: #FFFFFF;
          box-sizing: border-box;
          border: 1px solid #EDEDEF;
          box-shadow: 6px 6px 32px 0px rgba(39, 43, 141, 0.1);
          padding: 16px 12px;
          opacity: 0;
          transform: scale(0.1);
          transition: all 0.3s;
          transform-origin: 50% top;
        }
        .dropdown-item {
          cursor: pointer;
          border-radius: 8px;
          width: 104px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #86909C;
          &:nth-child(n+2) {
            margin-top: 4px;
          }
          &:hover {
            font-weight: 500;
          }
        }
        .item-switch:hover {
          background: #F5F6F9;
          color: #4E5969;
        }
        .item-logout:hover {
          background: #5B54FC14;
          color: #5B54FC;
        }
        .user-info {
          color: #616161;
          font-size: 16px;
          font-weight: 500;
          &.school {
            margin-left: 30px;
            margin-right: 30px;
          }
        }
      }
    }
  }
</style>
